import { render, staticRenderFns } from "./OfficeIdentityPage.vue?vue&type=template&id=6bb63e9c&scoped=true&"
import script from "./OfficeIdentityPage.vue?vue&type=script&lang=js&"
export * from "./OfficeIdentityPage.vue?vue&type=script&lang=js&"
import style0 from "./OfficeIdentityPage.vue?vue&type=style&index=0&id=6bb63e9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb63e9c",
  null
  
)

export default component.exports